export interface Bonus {
  title: string
  description: string
  value: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Musik-Kartenset',
    description: '40 Flashcards: Noten, Werte & Symbole.',
    value: '19 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a9624633-bb6d-4611-9788-ff9fb195f2fe.jpg',
  },
  {
    title: 'Musikspiele & Rätsel',
    description: '20 Spiele für die ganze Klasse, sofort spielbereit.',
    value: '27 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a0005ee1-199c-4c1a-9730-93d932b3dfe7.jpg',
  },
  {
    title: 'Poster-Paket',
    description:
      '8 Poster für den Musikraum: Quintenzirkel, Notenwerte, Instrumente.',
    value: '36 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ee6208e3-3dbe-45fa-84a8-8a054bced92b.jpg',
  },
  {
    title: 'Vertretungsstunden',
    description: '10 fertige Stunden — auch fachfremd durchführbar.',
    value: '19 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/dbc46cbf-f67a-4a48-b459-e832d5fa4ced.jpg',
  },
  {
    title: 'Urkunden & Belohnungen',
    description: 'Urkunden, Sticker-Tafeln und Fortschrittsblätter.',
    value: '27 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ea15f322-d9e1-4719-8d84-9f35caadb493.jpg',
  },
]
